<template>
  <div>
    <navHeader></navHeader>
    <div class="container-lg mt-5">
      <div class="row border-bottom">
        <div class="col-lg-8 col-md-12 col-12">
          <div class="p-3">
            <h2 class="main-title">Learning Guide Archive</h2>
            <label class="text-muted">
              A weekly interactive report that gives you technical studies on
              other markets that could have an impact on our very own local
              bourse. Get to know what we believe the charts are telling on Wall
              Street, on commodity prices, and on the foreign exchange market.
            </label>
          </div>
        </div>
        <div class="col-lg-4 col-md-12 col-12">
          <div
            class="p-3 d-flex align-items-center justify-content-lg-end mt-lg-5"
          >
            <date-picker
              class="date-picker"
              v-model="date"
              range
              :default-value="date"
              @clear="ChangeDate"
              :class="{ error: $v.date.$error }"
            ></date-picker>
            <button class="btn glob-btn" @click="Search(date)">Search</button>
          </div>
        </div>
      </div>
      <div class="archives" v-if="loading == false">
        <div
          v-for="(item, index) in generateList(LearningGuidanceArchive)[
            currentPage - 1
          ]"
          :key="index"
        >
          <div class="row">
            <div class="col-12 col-md-8 col-lg-6">
              <div class="p-3">
                <h5>{{ item.title }}</h5>
                <p class="text-muted m-0">
                  Posted on {{ FormatDate(item.date) }}
                </p>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <div class="p-3 child-selector">
                <a href="javascript:void(0)" @click="ViewReport(item)">
                  Read full research
                  <i class="bi bi-arrow-right"></i>
                </a>
              </div>
            </div>
          </div>
          <hr />
        </div>
      </div>

      <div class="d-flex justify-content-center mt-5">
        <b-pagination
          size="lg"
          v-model="currentPage"
          :total-rows="LearningGuidanceArchive.length"
          :per-page="perPage"
          v-if="LearningGuidanceArchive.length > perPage"
        ></b-pagination>
      </div>
      <Noresult
        v-if="LearningGuidanceArchive.length == 0 && loading == false"
      />
      <Searching v-if="loading == true" />
    </div>
  </div>
</template>
<script>
import navHeader from "../../NavHeader.vue";
import { mapState } from "vuex";
import moment from "moment";
import { required } from "vuelidate/lib/validators";
import Noresult from "../../NoResult";
import Searching from "../../Searching.vue";

export default {
  components: {
    navHeader,
    Noresult,
    Searching,
  },
  data() {
    return {
      perPage: 30,
      currentPage: 1,
      loading: false,
      date: [
        new Date(moment().startOf("year").format("MM/DD/YYYY")),
        new Date(moment().format("MM/DD/YYYY")),
      ],
      isDataLoaded: false,
      dateFrom: "",
      dateTo: "",
    };
  },
  computed: {
    ...mapState({
      LearningGuidanceArchive: (state) =>
        state.philstocksResearch.learningGuideArchive,
    }),
  },
  validations: {
    date: { required },
  },
  methods: {
    GoogleAnalytics() {
      this.$gtag.event("LearningGuideArchive", { method: "Google" });
    },
    ViewReport(data) {
      this.$store.dispatch(
        "philstocksResearch/GetLearningGuideReport",
        data.date
      );
      this.$router.push("/Reports/LearningGuide?date=" + data.date);
    },
    FormatDate(date) {
      var result = "";
      if (date == "0001-01-01T00:00:00") {
        result = "--";
      } else {
        result = moment(date).format("MMMM DD, YYYY");
      }
      return result;
    },
    async Search(data) {
      this.dateFrom = moment(data[0]).format("L");
      this.dateTo = moment(data[1]).format("L");
      var payload = {
        DateFrom: this.dateFrom,
        DateTo: this.dateTo,
      };
      this.$v.date.$touch();
      if (this.$v.date.$invalid) {
        this.dateFrom = "";
        this.dateTo = "";
      } else {
        var _this = this;
        this.loading = true;
        let searchArchive = await this.$store
          .dispatch("philstocksResearch/GetLearningGuideArchive", payload)
          .catch(function (error) {
            console.log(error);
            _this.loading = false;
          });
        if (searchArchive) {
          _this.loading = true;
        }
        _this.loading = false;
      }
    },

    ChangeDate() {
      this.dateFrom = "";
      this.dateTo = "";
      this.$v.date.$reset();
      this.date = [];
    },
    generateList(data) {
      var list = 30; // items per list
      var result = data.reduce((resultArray, item, index) => {
        const listIndex = Math.floor(index / list);
        if (!resultArray[listIndex]) {
          resultArray[listIndex] = []; // start a new list
        }
        resultArray[listIndex].push(item);
        return resultArray;
      }, []);
      return result;
    },

    async GetLearningGuideArchive() {
      var _this = this;
      this.loading = true;
      var payload = {
        DateFrom: moment().startOf("year").format("MM/DD/YYYY"),
        DateTo: moment().format("MM/DD/YYYY"),
      };
      let archive = await this.$store
        .dispatch("philstocksResearch/GetLearningGuideArchive", payload)
        .catch(function (error) {
          console.log(error);
          _this.loading = false;
        });
      if (archive) {
        _this.loading = true;
      }
      _this.loading = false;
    },
  },

  async mounted() {
    this.GetLearningGuideArchive();
  },
};
</script>
<style></style>
